@if (!platform()) {
  <div i18n>No video to display</div>
} @else if (platform() === 'vimeo') {
  <div class="video-container" style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;">
    <iframe
      [src]="src()"
      style="position:absolute;top:0;left:0;width:100%;height:100%;"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture">
    </iframe>
  </div>
} @else if (platform() === 'youtube') {
  <div class="video-container" style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;">
    <iframe
      [src]="src()"
      style="position:absolute;top:0;left:0;width:100%;height:100%;"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture">
    </iframe>
  </div>
} @else {
  <div i18n>Unsupported video platform</div>
}